import {
  determineGuardFn
} from "./chunk-XL7TH23H.mjs";
import {
  toArray
} from "./chunk-KQ6WGVFH.mjs";
import {
  isString
} from "./chunk-I7UKD6FS.mjs";

// src/transition-utils.ts
function toTarget(target) {
  return isString(target) ? { target } : target;
}
function determineTransitionFn(transitions, guardMap) {
  return (context, event, meta) => {
    return toArray(transitions).map(toTarget).find((transition) => {
      const determineGuard = determineGuardFn(transition.guard, guardMap);
      const guard = determineGuard(context, event, meta);
      return guard ?? transition.target ?? transition.actions;
    });
  };
}

export {
  toTarget,
  determineTransitionFn
};
